<div class="container-fluid">
  <!-- Page Header with Action Buttons -->
  <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
    <h1 class="page-header mb-2 mb-lg-0">Studio Business Summary Report</h1>

    <!-- Action Buttons -->
    <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center" style="margin-top: 0.5rem;">
      <div class="d-flex flex-wrap gap-1">
        <button
          [disabled]="this.isDisabled"
          [matTooltip]="disabledButtonTooltip"
          [matTooltipDisabled]="!this.isDisabled"
          style="color:#fff; background-color: #1C3F8B !important; border-color: #1C3F8B !important;"
          mat-flat-button
          class="me-1 mb-1"
          (click)="openDialog(SendUpdateAPIComponent, null, {
            endpoint: 'studio_business_send_api',
            operation: 'Send API',
            form: { week: week, year: year }
          });">Send Report</button>

        <button
          [disabled]="this.isDisabled"
          [matTooltip]="disabledButtonTooltip"
          [matTooltipDisabled]="!this.isDisabled"
          style="color:#fff; background-color: #1C3F8B !important; border-color: #1C3F8B !important;"
          mat-flat-button
          class="me-1 mb-1"
          (click)="openDialog(SendUpdateAPIComponent, null, {
            endpoint: 'studio_business_send_api',
            operation: 'Update API',
            form: { week: week, year: year }
          });">Update Report</button>

        <button style="background-color: transparent !important; border: none;"
          (click)="onPrint()"
          type="button"
          mat-icon-button
          class="me-1 mb-1"
          matTooltip="Print studio business summary"
          matTooltipPosition="below"
          aria-label="Print studio business summary">
          <mat-icon style="color: #1C3F8B;">print</mat-icon>
        </button>

        <button
          *ngIf="_permissionsService.isSuperAdmin()"
          style="color:#fff; background-color: #6c757d !important; border-color: #6c757d !important;"
          mat-flat-button
          class="me-1 mb-1"
          matTooltip="Super admin: clear the stored weekly tried/sold counters for this studio and recompute from current data"
          (click)="clearReportCache()">
          <mat-icon>autorenew</mat-icon>
        </button>

        <button
          style="color:#fff; background-color: #6c757d !important; border-color: #6c757d !important;"
          mat-flat-button
          class="me-1 mb-1"
          [routerLink]="['/ami-reports']">
          Back to list
        </button>
      </div>
    </div>
  </div>

  <app-report-nav-menu [week]="this.week" [year]="this.year" [currentReport]="this.currentReport"></app-report-nav-menu>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Filter
      </mat-panel-title>
      <mat-panel-description>
        <app-filter-results-panel [parameters]=queryParams></app-filter-results-panel>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="row">
      <app-week-year-selector
        [initialWeek]="week"
        [initialYear]="year"
        [disableOnFutureWeek]="true"
        [showNoneOption]="false"
        (selectionChange)="onWeekYearChange($event)"
        (isDisabledChange)="isDisabled = $event">
      </app-week-year-selector>

      <section class="section">
        <div class="float-end bring-inline">
          <button (click)="resetForm()" color="primary" mat-flat-button class="me-1" mat-button>Clear</button>
        </div>
      </section>
    </div>
  </mat-expansion-panel>

  <!-- Minimal Loading -->
  <div *ngIf="ShowProgressBar" class="text-center my-4">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <small class="text-muted mt-2 d-block">Loading report...</small>
  </div>


  <div class="table-responsive">
  <table class="mat-table cdk-table mat-sort mt-4" role="table" *ngIf="data != undefined">
    <thead role="rowgroup">
        <tr>
          <th class="mat-header-cell">Report Type</th>
          <th class="mat-header-cell">Studio</th>
          <th class="mat-header-cell">Prepared By</th>
          <th class="mat-header-cell">Year</th>
          <th class="mat-header-cell">Week Number</th>
          <th class="mat-header-cell">Date Range</th>
        </tr>
    </thead>
    <tr>
      <td class="mat-row">Studio Business</td>
      <td class="mat-row">{{ currentStudio }}</td>
      <td class="mat-row">{{ data['#prepared_by'] }}</td>
      <td class="mat-row">{{ data['#selectedData']['year'] }}</td>
      <td class="mat-row">{{ data['#selectedData']['week'] }}</td>
      <td class="mat-row">{{ reportDateService.formatDate(data['#date_start']) }} - {{ reportDateService.formatDate(data['#date_end']) }}</td>
    </tr>
  </table>
  </div>

  <!-- Compact Data Source Indicator -->
  <div *ngIf="consumable?.ytd_data_source && consumable.ytd_data_source !== 'Fallback - Original Data Only'" class="compact-data-source mt-1 mb-2 text-end">
    <small class="text-muted">
      <i class="material-icons align-middle" style="font-size: 14px;">info</i>
      <ng-container [ngSwitch]="consumable.ytd_data_source">
        <span *ngSwitchCase="'YTD from External System'">
          YTD data from
          <span class="badge bg-success text-white">
            <i class="material-icons" style="font-size: 12px; vertical-align: middle;">cloud</i>
            External System
          </span>
        </span>
        <span *ngSwitchDefault>
          YTD data shows
          <span class="badge bg-info text-dark">
            <i class="material-icons" style="font-size: 12px; vertical-align: middle;">cloud</i>
            {{ consumable.ytd_data_source }}
          </span>
        </span>
      </ng-container>
    </small>
  </div>

  <!-- YTD Processing Message -->
  <div *ngIf="data != undefined && !ShowProgressBar && !shouldShowReportData" class="text-center my-3">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <small class="text-muted mt-2 d-block">Processing data...</small>
  </div>

  <div class="row g-3" *ngIf="data != undefined && !ShowProgressBar && shouldShowReportData">
    <!-- {{ data?.['#studio_content_table']?.['studio_content_table']?.['#consumable'] | json}} -->
    <div class="col-12 col-lg-6 mb-4">
      <!-- CASH RECEIPTS -->
      <h2>Cash Receipts</h2>
      <table class="mat-table cdk-table mat-sort mt-4" role="table">
        <thead role="rowgroup">
          <tr>
            <th class="mat-header-cell"></th>
            <th class="mat-header-cell text-end">Lessons</th>
            <th class="mat-header-cell text-end">Misc</th>
            <th class="mat-header-cell text-end">Sundry</th>
            <th class="mat-header-cell text-end">Tax</th>
            <th class="mat-header-cell text-end">Totals</th>
          </tr>
        </thead>
        <tr>
          <td class="mat-row">Current</td>
          <td class="mat-row text-end">{{ this.consumable?.cash | studioCurrency }}</td>
          <td class="mat-row text-end">{{ this.consumable?.miscellaneous | studioCurrency }}</td>
          <td class="mat-row text-end">{{ this.consumable?.sundry | studioCurrency }}</td>
          <td class="mat-row text-end">{{ this.consumable?.tax | studioCurrency }}</td>
          <td class="mat-row text-end">{{ this.calculateTotal(this.consumable?.cash, this.consumable?.miscellaneous, this.consumable?.sundry, this.consumable?.tax) | studioCurrency }}</td>
        </tr>
        <tr>
          <td class="mat-row">Refund</td>
          <td class="mat-row text-end">({{ Math.abs(this.consumable?.refund_cash) | studioCurrency }})</td>
          <td class="mat-row text-end">({{ Math.abs(this.consumable?.refund_miscellaneous) | studioCurrency }})</td>
          <td class="mat-row text-end">({{ Math.abs(this.consumable?.refund_sundry) | studioCurrency }})</td>
          <td class="mat-row text-end">({{ Math.abs(this.consumable?.refund_tax) | studioCurrency }})</td>
          <td class="mat-row text-end">({{ Math.abs(this.calculateTotal(this.consumable?.refund_cash, this.consumable?.refund_miscellaneous, this.consumable?.refund_sundry, this.consumable?.refund_tax)) | studioCurrency }})</td>
        </tr>
        <tr>
          <td class="mat-row">Total</td>
          <td class="mat-row text-end">{{ this.roundNumber(this.consumable?.cash + this.consumable?.refund_cash) | studioCurrency }}</td>
          <td class="mat-row text-end">{{ this.roundNumber(this.consumable?.miscellaneous + this.consumable?.refund_miscellaneous) | studioCurrency }}</td>
          <td class="mat-row text-end">{{ this.roundNumber(this.consumable?.sundry + this.consumable?.refund_sundry) | studioCurrency }}</td>
          <td class="mat-row text-end">{{ this.roundNumber(this.consumable?.tax + this.consumable?.refund_tax) | studioCurrency }}</td>
          <td class="mat-row text-end">
            {{ this.calculateTotal(
              (this.consumable?.cash + this.consumable?.refund_cash),
              (this.consumable?.miscellaneous + this.consumable?.refund_miscellaneous),
              (this.consumable?.sundry + this.consumable?.refund_sundry),
              (this.consumable?.tax + this.consumable?.refund_tax)
            ) | studioCurrency }}
          </td>
        </tr>
        <tr>
          <td class="mat-row">YTD</td>
          <td class="mat-row text-end">
            <ng-container *ngIf="this.consumable?.cash_ytd_display?.fromOnlineReporting; else regularCashYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.cash_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: $' + consumable.ytd_data_from_api.cash_ytd +
                                ' + Current week: $' + consumable.cash +
                                ' = Total YTD: $' + consumable.cash_ytd :
                                'Data from Online Reporting'">
                {{ this.roundNumber(this.consumable?.cash_ytd) | studioCurrency }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularCashYtd>{{ this.roundNumber(this.consumable?.cash_ytd) | studioCurrency }}</ng-template>
          </td>
          <td class="mat-row text-end">
            <ng-container *ngIf="this.consumable?.miscellaneous_ytd_display?.fromOnlineReporting; else regularMiscYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.miscellaneous_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: $' + consumable.ytd_data_from_api.miscellaneous_ytd +
                                ' + Current week: $' + consumable.miscellaneous +
                                ' = Total YTD: $' + consumable.miscellaneous_ytd :
                                'Data from Online Reporting'">
                {{ this.roundNumber(this.consumable?.miscellaneous_ytd) | studioCurrency }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularMiscYtd>{{ this.roundNumber(this.consumable?.miscellaneous_ytd) | studioCurrency }}</ng-template>
          </td>
          <td class="mat-row text-end">
            <ng-container *ngIf="this.consumable?.sundry_ytd_display?.fromOnlineReporting; else regularSundryYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.sundry_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: $' + consumable.ytd_data_from_api.sundry_ytd +
                                ' + Current week: $' + consumable.sundry +
                                ' = Total YTD: $' + consumable.sundry_ytd :
                                'Data from Online Reporting'">
                {{ this.roundNumber(this.consumable?.sundry_ytd) | studioCurrency }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularSundryYtd>{{ this.roundNumber(this.consumable?.sundry_ytd) | studioCurrency }}</ng-template>
          </td>
          <td class="mat-row">-</td>
          <td class="mat-row text-end">
            <ng-container *ngIf="this.consumable?.cash_ytd_display?.fromOnlineReporting; else regularTotalYtd">
              <span class="online-reporting-data">{{ this.roundNumber(this.consumable?.cash_ytd + this.consumable?.miscellaneous_ytd + this.consumable?.sundry_ytd) | studioCurrency }} <i class="material-icons online-reporting-icon" matTooltip="Data from previous week YTD + current week">cloud</i></span>
            </ng-container>
            <ng-template #regularTotalYtd>{{ this.roundNumber(this.consumable?.cash_ytd + this.consumable?.miscellaneous_ytd + this.consumable?.sundry_ytd) | studioCurrency }}</ng-template>
          </td>
        </tr>
      </table>

      <!-- INQUIRIES -->
      <h2>Inquiries</h2>
      <table class="mat-table cdk-table mat-sort mt-4" role="table" *ngIf="data != undefined && !ShowProgressBar">
        <thead role="rowgroup">
            <tr>
                <th class="mat-header-cell"></th>
                <th class="mat-header-cell">Contact</th>
                <th class="mat-header-cell">Booked</th>
                <th class="mat-header-cell">Showed</th>
            </tr>
        </thead>
        <tr>
            <td class="mat-row"> Current </td>
            <td class="mat-row"
                [matTooltip]="consumable?.contact_tooltip || ''"
                [matTooltipDisabled]="!consumable?.contact_tooltip">
                {{ consumable?.contact ?? '0' }}
            </td>
            <td class="mat-row"
                [matTooltip]="consumable?.booked_tooltip || ''"
                [matTooltipDisabled]="!consumable?.booked_tooltip">
                {{ consumable?.booked ?? '0' }}
            </td>
            <td class="mat-row"
                [matTooltip]="consumable?.showed_tooltip || ''"
                [matTooltipDisabled]="!consumable?.showed_tooltip">
                {{ consumable?.showed ?? '0' }}
            </td>
        </tr>
        <tr>
            <td class="mat-row"> YTD </td>
            <td class="mat-row">
              <ng-container *ngIf="this.consumable?.contact_ytd_display?.fromOnlineReporting; else regularContactYtd">
                <span class="online-reporting-data"
                      [class.validation-error]="this.consumable?.contact_ytd_display?.hasValidationIssue"
                      [matTooltip]="this.consumable?.contact_ytd_display?.hasValidationIssue ?
                                   '⚠️ INVALID: YTD (' + consumable.contact_ytd + ') < Current (' + consumable.contact + ')' :
                                   (consumable?.contact_ytd_display?.includesCurrentWeek ?
                                    'Previous week YTD: ' + consumable.ytd_data_from_api.contact_ytd +
                                    ' + Current week: ' + consumable.contact +
                                    ' = Total YTD: ' + consumable.contact_ytd :
                                    'Data from Online Reporting')">
                  {{ this.consumable?.contact_ytd }}
                  <i class="material-icons online-reporting-icon"
                     [class.error-icon]="this.consumable?.contact_ytd_display?.hasValidationIssue">
                    {{ this.consumable?.contact_ytd_display?.hasValidationIssue ? 'error' : 'cloud' }}
                  </i>
                </span>
              </ng-container>
              <ng-template #regularContactYtd>{{ this.consumable?.contact_ytd }}</ng-template>
            </td>
            <td class="mat-row">
              <ng-container *ngIf="this.consumable?.booked_ytd_display?.fromOnlineReporting; else regularBookedYtd">
                <span class="online-reporting-data"
                      [class.validation-error]="this.consumable?.booked_ytd_display?.hasValidationIssue"
                      [matTooltip]="this.consumable?.booked_ytd_display?.hasValidationIssue ?
                                   '⚠️ INVALID: YTD (' + consumable.booked_ytd + ') < Current (' + consumable.booked + ')' :
                                   (consumable?.booked_ytd_display?.includesCurrentWeek ?
                                    'Previous week YTD: ' + consumable.ytd_data_from_api.booked_ytd +
                                    ' + Current week: ' + consumable.booked +
                                    ' = Total YTD: ' + consumable.booked_ytd :
                                    'Data from Online Reporting')">
                  {{ this.consumable?.booked_ytd }}
                  <i class="material-icons online-reporting-icon"
                     [class.error-icon]="this.consumable?.booked_ytd_display?.hasValidationIssue">
                    {{ this.consumable?.booked_ytd_display?.hasValidationIssue ? 'error' : 'cloud' }}
                  </i>
                </span>
              </ng-container>
              <ng-template #regularBookedYtd>{{ this.consumable?.booked_ytd }}</ng-template>
            </td>
            <td class="mat-row">
              <ng-container *ngIf="this.consumable?.showed_ytd_display?.fromOnlineReporting; else regularShowedYtd">
                <span class="online-reporting-data"
                      [class.validation-error]="this.consumable?.showed_ytd_display?.hasValidationIssue"
                      [matTooltip]="this.consumable?.showed_ytd_display?.hasValidationIssue ?
                                   '⚠️ INVALID: YTD (' + consumable.showed_ytd + ') < Current (' + consumable.showed + ')' :
                                   (consumable?.showed_ytd_display?.includesCurrentWeek ?
                                    'Previous week YTD: ' + consumable.ytd_data_from_api.showed_ytd +
                                    ' + Current week: ' + consumable.showed +
                                    ' = Total YTD: ' + consumable.showed_ytd :
                                    'Data from Online Reporting')">
                  {{ this.consumable?.showed_ytd }}
                  <i class="material-icons online-reporting-icon"
                     [class.error-icon]="this.consumable?.showed_ytd_display?.hasValidationIssue">
                    {{ this.consumable?.showed_ytd_display?.hasValidationIssue ? 'error' : 'cloud' }}
                  </i>
                </span>
              </ng-container>
              <ng-template #regularShowedYtd>{{ this.consumable?.showed_ytd }}</ng-template>
            </td>
        </tr>
    </table>


      <!-- LESSONS TAUGHT -->
      <h2>Lessons Taught</h2>
      <table class="mat-table cdk-table mat-sort mt-4" role="table" *ngIf="data != undefined && !ShowProgressBar">
        <thead role="rowgroup">
            <tr>
                <th class="mat-header-cell"></th>
                <th class="mat-header-cell">
                    <span class="text-nowrap" matTooltip="Units of Dance Evaluation, Bonus/Comp, and Barter/Trade lessons taught with a charged status (Showed, No Showed Charged, or Canceled Too Late). When sent to Online Reporting, these are included in the interviewed-lesson count.">DE/Bonus <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
                </th>
                <th class="mat-header-cell">
                    <span class="text-nowrap" matTooltip="Units of Front Department lessons taught with a charged status. Also includes Pre Original / Pre Original (Couple) lessons and Transfer lessons on Interview-department enrollments (Pre-Original, Original, Extension). When sent to Online Reporting, DE/Bonus lessons are added to this count.">Pvt. Int. <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
                </th>
                <th class="mat-header-cell">
                    <span class="text-nowrap" matTooltip="Units of Back Department lessons taught with a charged status. Also includes Transfer lessons on Renewal enrollments.">Pvt. Ren. <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
                </th>
                <th class="mat-header-cell text-end">
                    <span class="text-nowrap" matTooltip="Sum of DE/Bonus, Pvt. Int., and Pvt. Ren.">Totals</span>
                </th>
            </tr>
        </thead>
        <tr>
            <td class="mat-row">Current</td>
            <td class="mat-row">{{ this.consumable?.DE_lessons_taught }}</td>
            <td class="mat-row">{{ this.consumable?.PVT_interview_lessons_taught }}</td>
            <td class="mat-row">{{ this.consumable?.PVT_renewal_lessons_taught }}</td>
            <td class="mat-row text-end">{{ this.calculateTotal(this.consumable?.DE_lessons_taught, this.consumable?.PVT_interview_lessons_taught, this.consumable?.PVT_renewal_lessons_taught) }}</td>
        </tr>
        <tr>
            <td class="mat-row">YTD</td>
            <td class="mat-row">
              <ng-container *ngIf="this.consumable?.DE_lessons_taught_ytd_display?.fromOnlineReporting; else regularDEYtd">
                <span class="online-reporting-data"
                      [matTooltip]="consumable?.DE_lessons_taught_ytd_display?.includesCurrentWeek ?
                                  'Previous week YTD: ' + consumable.ytd_data_from_api.DE_lessons_taught_ytd +
                                  ' + Current week: ' + consumable.DE_lessons_taught +
                                  ' = Total YTD: ' + consumable.DE_lessons_taught_ytd :
                                  'Data from Online Reporting'">
                  {{ this.consumable?.DE_lessons_taught_ytd }}
                  <i class="material-icons online-reporting-icon">cloud</i>
                </span>
              </ng-container>
              <ng-template #regularDEYtd>{{ this.consumable?.DE_lessons_taught_ytd }}</ng-template>
            </td>
            <td class="mat-row">
              <ng-container *ngIf="this.consumable?.PVT_interview_lessons_taught_ytd_display?.fromOnlineReporting; else regularPvtIntYtd">
                <span class="online-reporting-data"
                      [matTooltip]="consumable?.PVT_interview_lessons_taught_ytd_display?.includesCurrentWeek ?
                                  'Previous week YTD: ' + consumable.ytd_data_from_api.PVT_interview_lessons_taught_ytd +
                                  ' + Current week: ' + consumable.PVT_interview_lessons_taught +
                                  ' = Total YTD: ' + consumable.PVT_interview_lessons_taught_ytd :
                                  'Data from Online Reporting'">
                  {{ this.consumable?.PVT_interview_lessons_taught_ytd }}
                  <i class="material-icons online-reporting-icon">cloud</i>
                </span>
              </ng-container>
              <ng-template #regularPvtIntYtd>{{ this.consumable?.PVT_interview_lessons_taught_ytd }}</ng-template>
            </td>
            <td class="mat-row">
              <ng-container *ngIf="this.consumable?.PVT_renewal_lessons_taught_ytd_display?.fromOnlineReporting; else regularPvtRenYtd">
                <span class="online-reporting-data"
                      [matTooltip]="consumable?.PVT_renewal_lessons_taught_ytd_display?.includesCurrentWeek ?
                                  'Previous week YTD: ' + consumable.ytd_data_from_api.PVT_renewal_lessons_taught_ytd +
                                  ' + Current week: ' + consumable.PVT_renewal_lessons_taught +
                                  ' = Total YTD: ' + consumable.PVT_renewal_lessons_taught_ytd :
                                  'Data from Online Reporting'">
                  {{ this.consumable?.PVT_renewal_lessons_taught_ytd }}
                  <i class="material-icons online-reporting-icon">cloud</i>
                </span>
              </ng-container>
              <ng-template #regularPvtRenYtd>{{ this.consumable?.PVT_renewal_lessons_taught_ytd }}</ng-template>
            </td>
            <td class="mat-row text-end">{{ this.calculateTotal(this.consumable?.DE_lessons_taught_ytd, this.consumable?.PVT_interview_lessons_taught_ytd, this.consumable?.PVT_renewal_lessons_taught_ytd) }}</td>
        </tr>
        <tr>
            <td class="mat-row">Active**</td>
            <td class="mat-row"></td>
            <td class="mat-row">{{ this.consumable?.active_students_interview_dpt }}</td>
            <td class="mat-row">{{ this.consumable?.active_students_renewal_dpt }}</td>
            <td class="mat-row text-end">{{ this.calculateTotal(this.consumable?.active_students_interview_dpt, this.consumable?.active_students_renewal_dpt) }}</td>
        </tr>
    </table>

      <table class="mat-table cdk-table mat-sort mt-4" role="table" *ngIf="data != undefined && !ShowProgressBar">
        <thead role="rowgroup">
            <tr>
                <th class="mat-header-cell"></th>
                <th class="mat-header-cell">
                    <span class="text-nowrap" matTooltip="Units of Transfer In lessons taught with a charged status. Note: transfer lessons are also included in Pvt. Int. or Pvt. Ren. based on the enrollment's department.">TTE In <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
                </th>
                <th class="mat-header-cell">
                    <span class="text-nowrap" matTooltip="Units of Transfer Out lessons taught with a charged status. Note: transfer lessons are also included in Pvt. Int. or Pvt. Ren. based on the enrollment's department.">TTE Out <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
                </th>
                <th class="mat-header-cell">
                    <span class="text-nowrap" matTooltip="Units of Non Unit Private lessons taught with a charged status, including coaching lessons (package lesson type Non Unit Private and SPS code Non Unit).">Non Unit/Coaching <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
                </th>
                <th class="mat-header-cell">
                    <span class="text-nowrap" matTooltip="Students taught in group classes with a charged status (Showed, No Showed Charged, or Canceled Too Late)."># in Class <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
                </th>
            </tr>
        </thead>
        <tr>
            <td class="mat-row">Current</td>
            <td class="mat-row">{{ this.consumable?.tte_in_lessons_taught }}</td>
            <td class="mat-row">{{ this.consumable?.tte_out_lessons_taught }}</td>
            <td class="mat-row">{{ this.calculateTotal(this.consumable?.non_unit_lessons_taught, this.consumable?.coaching_lessons_taught) }}</td>
            <td class="mat-row">{{ this.consumable?.number_in_class }}</td>
        </tr>
        <tr>
            <td class="mat-row">YTD</td>
            <td class="mat-row">{{ this.consumable?.tte_in_lessons_taught_ytd }}</td>
            <td class="mat-row">{{ this.consumable?.tte_out_lessons_taught_ytd }}</td>
            <td class="mat-row">{{ this.calculateTotal(this.consumable?.non_unit_lessons_taught_ytd, this.consumable?.coaching_lessons_taught_ytd) }}</td>
            <td class="mat-row">
              <ng-container *ngIf="this.consumable?.number_in_class_ytd_display?.fromOnlineReporting; else regularClassYtd">
                <span class="online-reporting-data"
                      [matTooltip]="consumable?.number_in_class_ytd_display?.includesCurrentWeek ?
                                  'Previous week YTD: ' + consumable.ytd_data_from_api.number_in_class_ytd +
                                  ' + Current week: ' + consumable.number_in_class +
                                  ' = Total YTD: ' + consumable.number_in_class_ytd :
                                  'Data from Online Reporting'">
                  {{ this.consumable?.number_in_class_ytd }}
                  <i class="material-icons online-reporting-icon">cloud</i>
                </span>
              </ng-container>
              <ng-template #regularClassYtd>{{ this.consumable?.number_in_class_ytd }}</ng-template>
            </td>
        </tr>
    </table>


      <!-- DROPS -->
      <h2>Drops</h2>
      <table class="mat-table cdk-table mat-sort mt-4" role="table" *ngIf="data != undefined && !ShowProgressBar">
        <thead role="rowgroup">
            <tr>
                <th class="mat-header-cell"></th>
                <th class="mat-header-cell text-end">PORI</th>
                <th class="mat-header-cell text-end">ORI</th>
                <th class="mat-header-cell text-end">EXT</th>
                <th class="mat-header-cell text-end">REN</th>
                <th class="mat-header-cell text-end">NUNIT</th>
                <th class="mat-header-cell text-end">MISC</th>
            </tr>
        </thead>
        <tr>
            <td class="mat-row">Units</td>
            <td class="mat-row text-end">{{ this.consumable?.pre_original_units_dropped }}</td>
            <td class="mat-row text-end">{{ this.consumable?.original_units_dropped }}</td>
            <td class="mat-row text-end">{{ this.consumable?.extension_units_dropped }}</td>
            <td class="mat-row text-end">{{ this.consumable?.renewal_units_dropped }}</td>
            <td class="mat-row text-end">{{ this.consumable?.non_unit_units_dropped }}</td>
            <td class="mat-row text-end">{{ this.consumable?.miscellaneous_units_dropped }}</td>
        </tr>
        <tr>
            <td class="mat-row">Sales</td>
            <td class="mat-row text-end">{{ this.consumable?.pre_original_sales_dropped | studioCurrency }}
              <span *ngIf="this.consumable?.pre_original_sales_dropped_ui?.length"
                    class="info-tooltip"
                    [htmlTooltip]="getDroppedEnrollmentTooltip('pre_original', false)">
                <i class="material-icons">info</i>
              </span>
            </td>
            <td class="mat-row text-end">{{ this.consumable?.original_sales_dropped | studioCurrency }}
              <span *ngIf="this.consumable?.original_sales_dropped_ui?.length"
                    class="info-tooltip"
                    [htmlTooltip]="getDroppedEnrollmentTooltip('original', false)">
                <i class="material-icons">info</i>
              </span>
            </td>
            <td class="mat-row text-end">{{ this.consumable?.extension_sales_dropped | studioCurrency }}
              <span *ngIf="this.consumable?.extension_sales_dropped_ui?.length"
                    class="info-tooltip"
                    [htmlTooltip]="getDroppedEnrollmentTooltip('extension', false)">
                <i class="material-icons">info</i>
              </span>
            </td>
            <td class="mat-row text-end">{{ this.consumable?.renewal_sales_dropped | studioCurrency }}
              <span *ngIf="this.consumable?.renewal_sales_dropped_ui?.length"
                    class="info-tooltip"
                    [htmlTooltip]="getDroppedEnrollmentTooltip('renewal', false)">
                <i class="material-icons">info</i>
              </span>
            </td>
            <td class="mat-row text-end">{{ this.consumable?.non_unit_sales_dropped | studioCurrency }}</td>
            <td class="mat-row text-end">{{ this.consumable?.miscellaneous_sales_dropped | studioCurrency }}</td>
        </tr>
        <tr>
            <td class="mat-row">YTD Units</td>
            <td class="mat-row text-end">{{ this.consumable?.pre_original_units_dropped_ytd }}</td>
            <td class="mat-row text-end">{{ this.consumable?.original_units_dropped_ytd }}</td>
            <td class="mat-row text-end">{{ this.consumable?.extension_units_dropped_ytd }}</td>
            <td class="mat-row text-end">{{ this.consumable?.renewal_units_dropped_ytd }}</td>
            <td class="mat-row text-end">{{ this.consumable?.non_unit_units_dropped_ytd }}</td>
            <td class="mat-row text-end">{{ this.consumable?.miscellaneous_units_dropped_ytd }}</td>
        </tr>
        <tr>
            <td class="mat-row">YTD Sales</td>
            <td class="mat-row text-end">{{ this.consumable?.pre_original_sales_dropped_ytd | studioCurrency }}
              <span *ngIf="this.consumable?.pre_original_sales_dropped_ytd_ui?.length"
                    class="info-tooltip"
                    [htmlTooltip]="getDroppedEnrollmentTooltip('pre_original', true)">
                <i class="material-icons">info</i>
              </span>
            </td>
            <td class="mat-row text-end">{{ this.consumable?.original_sales_dropped_ytd | studioCurrency }}
              <span *ngIf="this.consumable?.original_sales_dropped_ytd_ui?.length"
                    class="info-tooltip"
                    [htmlTooltip]="getDroppedEnrollmentTooltip('original', true)">
                <i class="material-icons">info</i>
              </span>
            </td>
            <td class="mat-row text-end">{{ this.consumable?.extension_sales_dropped_ytd | studioCurrency }}
              <span *ngIf="this.consumable?.extension_sales_dropped_ytd_ui?.length"
                    class="info-tooltip"
                    [htmlTooltip]="getDroppedEnrollmentTooltip('extension', true)">
                <i class="material-icons">info</i>
              </span>
            </td>
            <td class="mat-row text-end">{{ this.consumable?.renewal_sales_dropped_ytd | studioCurrency }}
              <span *ngIf="this.consumable?.renewal_sales_dropped_ytd_ui?.length"
                    class="info-tooltip"
                    [htmlTooltip]="getDroppedEnrollmentTooltip('renewal', true)">
                <i class="material-icons">info</i>
              </span>
            </td>
            <td class="mat-row text-end">{{ this.consumable?.non_unit_sales_dropped_ytd | studioCurrency }}</td>
            <td class="mat-row text-end">{{ this.consumable?.miscellaneous_sales_dropped_ytd | studioCurrency }}</td>
        </tr>
    </table>
    </div>

    <div class="col-12 col-lg-6 mb-4">
      <!-- UNIT SALES TRACKING -->
      <h2>Unit Sales Tracking</h2>
      <table class="mat-table cdk-table mat-sort mt-4" role="table" *ngIf="data != undefined && !ShowProgressBar">
        <thead role="rowgroup">
            <tr>
              <th class="mat-header-cell">DE/Bonus</th>
              <th class="mat-header-cell">Tries</th>
              <th class="mat-header-cell">Sold</th>
              <th class="mat-header-cell">Units</th>
              <th class="mat-header-cell text-end">Sales</th>
            </tr>
        </thead>
        <tr>
          <td class="mat-row">Current</td>
          <td class="mat-row">{{ this.consumable?.DE_tried }}</td>
          <td class="mat-row">{{ this.consumable?.DE_sold }}</td>
          <td class="mat-row">{{ this.consumable?.DE_units }}</td>
          <td class="mat-row">{{ this.consumable?.DE_sales }}-</td>
        </tr>
        <tr>
          <td class="mat-row">YTD</td>
          <td class="mat-row">
            <ng-container *ngIf="this.consumable?.DE_tried_ytd_display?.fromOnlineReporting; else regularDETriedYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.DE_tried_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: ' + consumable.ytd_data_from_api.DE_tried_ytd +
                                ' + Current week: ' + consumable.DE_tried +
                                ' = Total YTD: ' + consumable.DE_tried_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.DE_tried_ytd }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularDETriedYtd>{{ this.consumable?.DE_tried_ytd }}</ng-template>
          </td>
          <td class="mat-row">
            <ng-container *ngIf="this.consumable?.DE_sold_ytd_display?.fromOnlineReporting; else regularDESoldYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.DE_sold_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: ' + consumable.ytd_data_from_api.DE_sold_ytd +
                                ' + Current week: ' + consumable.DE_sold +
                                ' = Total YTD: ' + consumable.DE_sold_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.DE_sold_ytd }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularDESoldYtd>{{ this.consumable?.DE_sold_ytd }}</ng-template>
          </td>
          <td class="mat-row">
            <ng-container *ngIf="this.consumable?.DE_units_ytd_display?.fromOnlineReporting; else regularDEUnitsYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.DE_units_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: ' + consumable.ytd_data_from_api.DE_units_ytd +
                                ' + Current week: ' + consumable.DE_units +
                                ' = Total YTD: ' + consumable.DE_units_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.DE_units_ytd }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularDEUnitsYtd>{{ this.consumable?.DE_units_ytd }}</ng-template>
          </td>
          <td class="mat-row">{{ this.consumable?.DE_sales_ytd }}-</td>
        </tr>
        <thead role="rowgroup">
            <tr>
              <th class="mat-header-cell">Pre-Original</th>
              <th class="mat-header-cell"></th>
              <th class="mat-header-cell"></th>
              <th class="mat-header-cell"></th>
              <th class="mat-header-cell"></th>
            </tr>
        </thead>
        <tr>
          <td class="mat-row">Current</td>
          <td class="mat-row">{{ this.consumable?.pre_original_tried }}</td>
          <td class="mat-row">{{ this.consumable?.pre_original_sold }}</td>
          <td class="mat-row">{{ this.consumable?.pre_original_units }}</td>
          <td class="mat-row text-end">{{ this.consumable?.pre_original_sales | studioCurrency }}</td>
        </tr>
        <tr>
          <td class="mat-row">YTD</td>
          <td class="mat-row">
            <ng-container *ngIf="this.consumable?.pre_original_tried_ytd_display?.fromOnlineReporting; else regularPOTriedYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.pre_original_tried_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: ' + consumable.ytd_data_from_api.pre_original_tried_ytd +
                                ' + Current week: ' + consumable.pre_original_tried +
                                ' = Total YTD: ' + consumable.pre_original_tried_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.pre_original_tried_ytd }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularPOTriedYtd>{{ this.consumable?.pre_original_tried_ytd }}</ng-template>
          </td>
          <td class="mat-row">
            <ng-container *ngIf="this.consumable?.pre_original_sold_ytd_display?.fromOnlineReporting; else regularPOSoldYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.pre_original_sold_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: ' + consumable.ytd_data_from_api.pre_original_sold_ytd +
                                ' + Current week: ' + consumable.pre_original_sold +
                                ' = Total YTD: ' + consumable.pre_original_sold_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.pre_original_sold_ytd }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularPOSoldYtd>{{ this.consumable?.pre_original_sold_ytd }}</ng-template>
          </td>
          <td class="mat-row">
            <ng-container *ngIf="this.consumable?.pre_original_units_ytd_display?.fromOnlineReporting; else regularPOUnitsYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.pre_original_units_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: ' + consumable.ytd_data_from_api.pre_original_units_ytd +
                                ' + Current week: ' + consumable.pre_original_units +
                                ' = Total YTD: ' + consumable.pre_original_units_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.pre_original_units_ytd }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularPOUnitsYtd>{{ this.consumable?.pre_original_units_ytd }}</ng-template>
          </td>
          <td class="mat-row text-end">
            <ng-container *ngIf="this.consumable?.pre_original_sales_ytd_display?.fromOnlineReporting; else regularPOSalesYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.pre_original_sales_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: $' + consumable.ytd_data_from_api.pre_original_sales_ytd +
                                ' + Current week: $' + consumable.pre_original_sales +
                                ' = Total YTD: $' + consumable.pre_original_sales_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.pre_original_sales_ytd | studioCurrency }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularPOSalesYtd>{{ this.consumable?.pre_original_sales_ytd | studioCurrency }}</ng-template>
          </td>
        </tr>
        <thead role="rowgroup">
            <tr>
              <th class="mat-header-cell">Original</th>
              <th class="mat-header-cell"></th>
              <th class="mat-header-cell"></th>
              <th class="mat-header-cell"></th>
              <th class="mat-header-cell"></th>
            </tr>
        </thead>
        <tr>
          <td class="mat-row">Current</td>
          <td class="mat-row">{{ this.consumable?.original_tried }}</td>
          <td class="mat-row">{{ this.consumable?.original_sold }}</td>
          <td class="mat-row">{{ this.consumable?.original_units }}</td>
          <td class="mat-row text-end">{{ this.consumable?.original_sales | studioCurrency }}</td>
        </tr>
        <tr>
          <td class="mat-row">YTD</td>
          <td class="mat-row">
            <ng-container *ngIf="this.consumable?.original_tried_ytd_display?.fromOnlineReporting; else regularOrigTriedYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.original_tried_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: ' + consumable.ytd_data_from_api.original_tried_ytd +
                                ' + Current week: ' + consumable.original_tried +
                                ' = Total YTD: ' + consumable.original_tried_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.original_tried_ytd }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularOrigTriedYtd>{{ this.consumable?.original_tried_ytd }}</ng-template>
          </td>
          <td class="mat-row">
            <ng-container *ngIf="this.consumable?.original_sold_ytd_display?.fromOnlineReporting; else regularOrigSoldYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.original_sold_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: ' + consumable.ytd_data_from_api.original_sold_ytd +
                                ' + Current week: ' + consumable.original_sold +
                                ' = Total YTD: ' + consumable.original_sold_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.original_sold_ytd }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularOrigSoldYtd>{{ this.consumable?.original_sold_ytd }}</ng-template>
          </td>
          <td class="mat-row">
            <ng-container *ngIf="this.consumable?.original_units_ytd_display?.fromOnlineReporting; else regularOrigUnitsYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.original_units_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: ' + consumable.ytd_data_from_api.original_units_ytd +
                                ' + Current week: ' + consumable.original_units +
                                ' = Total YTD: ' + consumable.original_units_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.original_units_ytd }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularOrigUnitsYtd>{{ this.consumable?.original_units_ytd }}</ng-template>
          </td>
          <td class="mat-row text-end">
            <ng-container *ngIf="this.consumable?.original_sales_ytd_display?.fromOnlineReporting; else regularOrigSalesYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.original_sales_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: ' + consumable.ytd_data_from_api.original_sales_ytd +
                                ' + Current week: ' + consumable.original_sales +
                                ' = Total YTD: ' + consumable.original_sales_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.original_sales_ytd | studioCurrency }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularOrigSalesYtd>{{ this.consumable?.original_sales_ytd | studioCurrency }}</ng-template>
          </td>
        </tr>
        <thead role="rowgroup">
            <tr>
              <th class="mat-header-cell">Extension</th>
              <th class="mat-header-cell"></th>
              <th class="mat-header-cell"></th>
              <th class="mat-header-cell"></th>
              <th class="mat-header-cell"></th>
            </tr>
        </thead>
        <tr>
          <td class="mat-row">Current</td>
          <td class="mat-row">{{ this.consumable?.extension_tried }}</td>
          <td class="mat-row">{{ this.consumable?.extension_sold }}</td>
          <td class="mat-row">{{ this.consumable?.extension_units }}</td>
          <td class="mat-row text-end">{{ this.consumable?.extension_sales | studioCurrency }}</td>
        </tr>
        <tr>
          <td class="mat-row">YTD</td>
          <td class="mat-row">
            <ng-container *ngIf="this.consumable?.extension_tried_ytd_display?.fromOnlineReporting; else regularExtTriedYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.extension_tried_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: ' + consumable.ytd_data_from_api.extension_tried_ytd +
                                ' + Current week: ' + consumable.extension_tried +
                                ' = Total YTD: ' + consumable.extension_tried_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.extension_tried_ytd }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularExtTriedYtd>{{ this.consumable?.extension_tried_ytd }}</ng-template>
          </td>
          <td class="mat-row">
            <ng-container *ngIf="this.consumable?.extension_sold_ytd_display?.fromOnlineReporting; else regularExtSoldYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.extension_sold_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: ' + consumable.ytd_data_from_api.extension_sold_ytd +
                                ' + Current week: ' + consumable.extension_sold +
                                ' = Total YTD: ' + consumable.extension_sold_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.extension_sold_ytd }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularExtSoldYtd>{{ this.consumable?.extension_sold_ytd }}</ng-template>
          </td>
          <td class="mat-row">
            <ng-container *ngIf="this.consumable?.extension_units_ytd_display?.fromOnlineReporting; else regularExtUnitsYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.extension_units_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: ' + consumable.ytd_data_from_api.extension_units_ytd +
                                ' + Current week: ' + consumable.extension_units +
                                ' = Total YTD: ' + consumable.extension_units_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.extension_units_ytd }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularExtUnitsYtd>{{ this.consumable?.extension_units_ytd }}</ng-template>
          </td>
          <td class="mat-row text-end">
            <ng-container *ngIf="this.consumable?.extension_sales_ytd_display?.fromOnlineReporting; else regularExtSalesYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.extension_sales_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: ' + consumable.ytd_data_from_api.extension_sales_ytd +
                                ' + Current week: ' + consumable.extension_sales +
                                ' = Total YTD: ' + consumable.extension_sales_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.extension_sales_ytd | studioCurrency }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularExtSalesYtd>{{ this.consumable?.extension_sales_ytd | studioCurrency }}</ng-template>
          </td>
        </tr>
        <thead role="rowgroup">
            <tr>
              <th class="mat-header-cell">Renewal</th>
              <th class="mat-header-cell"></th>
              <th class="mat-header-cell"></th>
              <th class="mat-header-cell"></th>
              <th class="mat-header-cell"></th>
            </tr>
        </thead>
        <tr>
          <td class="mat-row">Current</td>
          <td class="mat-row">{{ this.consumable?.renewal_tried }}</td>
          <td class="mat-row">{{ this.consumable?.renewal_sold }}</td>
          <td class="mat-row">{{ this.consumable?.renewal_units }}</td>
          <td class="mat-row text-end">{{ this.consumable?.renewal_sales | studioCurrency }}</td>
        </tr>
        <tr>
          <td class="mat-row">YTD</td>
          <td class="mat-row">
            <ng-container *ngIf="this.consumable?.renewal_tried_ytd_display?.fromOnlineReporting; else regularRenTriedYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.renewal_tried_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: ' + consumable.ytd_data_from_api.renewal_tried_ytd +
                                ' + Current week: ' + consumable.renewal_tried +
                                ' = Total YTD: ' + consumable.renewal_tried_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.renewal_tried_ytd }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularRenTriedYtd>{{ this.consumable?.renewal_tried_ytd }}</ng-template>
          </td>
          <td class="mat-row">
            <ng-container *ngIf="this.consumable?.renewal_sold_ytd_display?.fromOnlineReporting; else regularRenSoldYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.renewal_sold_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: ' + consumable.ytd_data_from_api.renewal_sold_ytd +
                                ' + Current week: ' + consumable.renewal_sold +
                                ' = Total YTD: ' + consumable.renewal_sold_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.renewal_sold_ytd }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularRenSoldYtd>{{ this.consumable?.renewal_sold_ytd }}</ng-template>
          </td>
          <td class="mat-row">
            <ng-container *ngIf="this.consumable?.renewal_units_ytd_display?.fromOnlineReporting; else regularRenUnitsYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.renewal_units_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: ' + consumable.ytd_data_from_api.renewal_units_ytd +
                                ' + Current week: ' + consumable.renewal_units +
                                ' = Total YTD: ' + consumable.renewal_units_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.renewal_units_ytd }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularRenUnitsYtd>{{ this.consumable?.renewal_units_ytd }}</ng-template>
          </td>
          <td class="mat-row text-end">
            <ng-container *ngIf="this.consumable?.renewal_sales_ytd_display?.fromOnlineReporting; else regularRenSalesYtd">
              <span class="online-reporting-data"
                    [matTooltip]="consumable?.renewal_sales_ytd_display?.includesCurrentWeek ?
                                'Previous week YTD: ' + consumable.ytd_data_from_api.renewal_sales_ytd +
                                ' + Current week: ' + consumable.renewal_sales +
                                ' = Total YTD: ' + consumable.renewal_sales_ytd :
                                'Data from Online Reporting'">
                {{ this.consumable?.renewal_sales_ytd | studioCurrency }}
                <i class="material-icons online-reporting-icon">cloud</i>
              </span>
            </ng-container>
            <ng-template #regularRenSalesYtd>{{ this.consumable?.renewal_sales_ytd | studioCurrency }}</ng-template>
          </td>
        </tr>
        <thead role="rowgroup">
            <tr>
              <th class="mat-header-cell">Total</th>
              <th class="mat-header-cell"></th>
              <th class="mat-header-cell"></th>
              <th class="mat-header-cell"></th>
              <th class="mat-header-cell"></th>
            </tr>
        </thead>
        <tr>
          <td class="mat-row">Current</td>
          <td class="mat-row">
            {{
              this.consumable?.DE_tried
            + this.consumable?.pre_original_tried
            + this.consumable?.original_tried
            + this.consumable?.extension_tried
            + this.consumable?.renewal_tried
            }}
          </td>
          <td class="mat-row">
            {{
              this.consumable?.DE_sold
            + this.consumable?.pre_original_sold
            + this.consumable?.original_sold
            + this.consumable?.extension_sold
            + this.consumable?.renewal_sold
            }}
          </td>
          <td class="mat-row">
            {{
              this.consumable?.DE_units
            + this.consumable?.pre_original_units
            + this.consumable?.original_units
            + this.consumable?.extension_units
            + this.consumable?.renewal_units
            }}
          </td>
          <td class="mat-row text-end">
            {{ this.calculateTotal(
              this.consumable?.pre_original_sales,
              this.consumable?.original_sales,
              this.consumable?.extension_sales,
              this.consumable?.renewal_sales
            ) | studioCurrency }}
          </td>
        </tr>
        <tr>
          <td class="mat-row">YTD</td>
          <td class="mat-row">
            {{
              (this.consumable?.DE_tried_ytd || 0)
            + (this.consumable?.pre_original_tried_ytd || 0)
            + (this.consumable?.original_tried_ytd || 0)
            + (this.consumable?.extension_tried_ytd || 0)
            + (this.consumable?.renewal_tried_ytd || 0)
            }}
          </td>
          <td class="mat-row">
            {{
              (this.consumable?.DE_sold_ytd || 0)
            + (this.consumable?.pre_original_sold_ytd || 0)
            + (this.consumable?.original_sold_ytd || 0)
            + (this.consumable?.extension_sold_ytd || 0)
            + (this.consumable?.renewal_sold_ytd || 0)
            }}
          </td>
          <td class="mat-row">
            {{
              (this.consumable?.DE_units_ytd || 0)
            + (this.consumable?.pre_original_units_ytd || 0)
            + (this.consumable?.original_units_ytd || 0)
            + (this.consumable?.extension_units_ytd || 0)
            + (this.consumable?.renewal_units_ytd || 0)
            }}
          </td>
          <td class="mat-row text-end">
            {{ this.calculateTotal(
              this.consumable?.pre_original_sales_ytd,
              this.consumable?.original_sales_ytd,
              this.consumable?.extension_sales_ytd,
              this.consumable?.renewal_sales_ytd
            ) | studioCurrency }}
          </td>
        </tr>
      </table>

      <div class="row">
        <div class="col-12 col-lg-6 mb-3">
          <!-- NON-UNIT SALES -->
          <h2>Non-Unit Sales</h2>
          <table class="mat-table cdk-table mat-sort mt-4" role="table" *ngIf="data != undefined && !ShowProgressBar">
            <thead role="rowgroup">
                <tr>
                  <th class="mat-header-cell">PVT/Coach</th>
                  <th class="mat-header-cell">Lessons</th>
                  <th class="mat-header-cell text-end">Sales</th>
                </tr>
            </thead>
            <tr>
              <td class="mat-row"> Current </td>
              <td class="mat-row"> {{ consumable?.non_unit_private_lessons }} </td>
              <td class="mat-row text-end"> {{ consumable?.non_unit_private_sales | studioCurrency }} </td>
            </tr>
            <tr>
              <td class="mat-row"> YTD </td>
              <td class="mat-row">
                <ng-container *ngIf="this.consumable?.non_unit_private_lessons_ytd_display?.fromOnlineReporting; else regularNonUnitLessonsYtd">
                  <span class="online-reporting-data"
                        [matTooltip]="consumable?.non_unit_private_lessons_ytd_display?.includesCurrentWeek ?
                                    'Previous week YTD: ' + consumable.ytd_data_from_api.non_unit_private_lessons_ytd +
                                    ' + Current week: ' + consumable.non_unit_private_lessons +
                                    ' = Total YTD: ' + consumable.non_unit_private_lessons_ytd :
                                    'Data from Online Reporting'">
                    {{ this.consumable?.non_unit_private_lessons_ytd }}
                    <i class="material-icons online-reporting-icon">cloud</i>
                  </span>
                </ng-container>
                <ng-template #regularNonUnitLessonsYtd>{{ this.consumable?.non_unit_private_lessons_ytd }}</ng-template>
              </td>
              <td class="mat-row text-end">
                <ng-container *ngIf="this.consumable?.non_unit_private_sales_ytd_display?.fromOnlineReporting; else regularNonUnitSalesYtd">
                  <span class="online-reporting-data"
                        [matTooltip]="consumable?.non_unit_private_sales_ytd_display?.includesCurrentWeek ?
                                    'Previous week YTD: $' + consumable.ytd_data_from_api.non_unit_private_sales_ytd +
                                    ' + Current week: $' + consumable.non_unit_private_sales +
                                    ' = Total YTD: $' + consumable.non_unit_private_sales_ytd :
                                    'Data from Online Reporting'">
                    {{ this.consumable?.non_unit_private_sales_ytd | studioCurrency }}
                    <i class="material-icons online-reporting-icon">cloud</i>
                  </span>
                </ng-container>
                <ng-template #regularNonUnitSalesYtd>{{ this.consumable?.non_unit_private_sales_ytd | studioCurrency }}</ng-template>
              </td>
            </tr>
          </table>
          <table class="mat-table cdk-table mat-sort mt-4" role="table" *ngIf="data != undefined && !ShowProgressBar">
            <thead role="rowgroup">
                <tr>
                  <th class="mat-header-cell">Class</th>
                  <th class="mat-header-cell"></th>
                  <th class="mat-header-cell text-end"></th>
                </tr>
            </thead>
            <tr>
              <td class="mat-row"> Current </td>
              <td class="mat-row"> {{ consumable?.non_unit_class_lessons }} </td>
              <td class="mat-row text-end"> {{ consumable?.non_unit_class_sales | studioCurrency }} </td>
            </tr>
            <tr>
              <td class="mat-row"> YTD </td>
              <td class="mat-row">
                <ng-container *ngIf="this.consumable?.non_unit_class_lessons_ytd_display?.fromOnlineReporting; else regularClassLessonsYtd">
                  <span class="online-reporting-data"
                        [matTooltip]="consumable?.non_unit_class_lessons_ytd_display?.includesCurrentWeek ?
                                    'Previous week YTD: ' + consumable.ytd_data_from_api.non_unit_class_lessons_ytd +
                                    ' + Current week: ' + consumable.non_unit_class_lessons +
                                    ' = Total YTD: ' + consumable.non_unit_class_lessons_ytd :
                                    'Data from Online Reporting'">
                    {{ this.consumable?.non_unit_class_lessons_ytd }}
                    <i class="material-icons online-reporting-icon">cloud</i>
                  </span>
                </ng-container>
                <ng-template #regularClassLessonsYtd>{{ this.consumable?.non_unit_class_lessons_ytd }}</ng-template>
              </td>
              <td class="mat-row text-end">
                <ng-container *ngIf="this.consumable?.non_unit_class_sales_ytd_display?.fromOnlineReporting; else regularClassSalesYtd">
                  <span class="online-reporting-data"
                        [matTooltip]="consumable?.non_unit_class_sales_ytd_display?.includesCurrentWeek ?
                                    'Previous week YTD: $' + consumable.ytd_data_from_api.non_unit_class_sales_ytd +
                                    ' + Current week: $' + consumable.non_unit_class_sales +
                                    ' = Total YTD: $' + consumable.non_unit_class_sales_ytd :
                                    'Data from Online Reporting'">
                    {{ this.consumable?.non_unit_class_sales_ytd | studioCurrency }}
                    <i class="material-icons online-reporting-icon">cloud</i>
                  </span>
                </ng-container>
                <ng-template #regularClassSalesYtd>{{ this.consumable?.non_unit_class_sales_ytd | studioCurrency }}</ng-template>
              </td>
            </tr>
          </table>
        </div>

        <div class="col-12 col-lg-6 mb-3">
          <!-- MISCELLANEOUS -->
          <h2>Miscellaneous</h2>
          <table class="mat-table cdk-table mat-sort mt-4" role="table">
            <thead role="rowgroup">
                <tr>
                  <th class="mat-header-cell">Events</th>
                  <th class="mat-header-cell text-end">Sales</th>
                </tr>
            </thead>
            <tr>
              <td class="mat-row"> Current </td>
              <td class="mat-row text-end"> {{ consumable?.miscellaneous_sales | studioCurrency }} </td>
            </tr>
            <tr>
              <td class="mat-row"> YTD </td>
              <td class="mat-row text-end">
                <ng-container *ngIf="this.consumable?.miscellaneous_sales_ytd_display?.fromOnlineReporting; else regularMiscSalesYtd">
                  <span class="online-reporting-data"
                        [matTooltip]="consumable?.miscellaneous_sales_ytd_display?.includesCurrentWeek ?
                                    'Previous week YTD: $' + consumable.ytd_data_from_api.miscellaneous_sales_ytd +
                                    ' + Current week: $' + consumable.miscellaneous_sales +
                                    ' = Total YTD: $' + consumable.miscellaneous_sales_ytd :
                                    'Data from Online Reporting'">
                    {{ this.consumable?.miscellaneous_sales_ytd | studioCurrency }}
                    <i class="material-icons online-reporting-icon">cloud</i>
                  </span>
                </ng-container>
                <ng-template #regularMiscSalesYtd>{{ this.consumable?.miscellaneous_sales_ytd | studioCurrency }}</ng-template>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

  </div>

  <div class="table-container d-none">

    <table mat-table #displayTable [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="mt-4">

      <!-- name Column -->
      <ng-container matColumnDef="column_1">
        <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Name">
          column_1
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container>{{ element[0].data }}</ng-container>
        </td>
      </ng-container>

      <!-- name Column -->
      <ng-container matColumnDef="column_2">
          <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Name">
              column_2
          </th>
          <td mat-cell *matCellDef="let element">
            <ng-container>{{ element[1] }}</ng-container>
          </td>
        </ng-container>

      <!-- REPLACE Column -->
      <!-- <ng-container matColumnDef="REPLACE">
        <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by REPLACE">
          REPLACE
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.REPLACE">{{ element.REPLACE }}</ng-container>
        </td>
      </ng-container> -->

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row matRipple *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <ng-container *ngIf="this.pageSize == 0">
      <div>
        Please select criteria to generate a report.
      </div>
    </ng-container>

    <!-- <mat-paginator (page)="pageChanged($event)" [pageSizeOptions]="onPageSizeOptions()" [length]="10"
      [disabled]="ShowProgressBar"
      [pageSize]="paginationTotalPages" [pageIndex]="paginationIndex" aria-label="Select page of view"></mat-paginator> -->

  </div>
</div>
